import { STARTER_SUITE_ONBOARDING_SCOPES, PRO_SUITE_ONBOARDING_SCOPES, ENTERPRISE_SUITE_ONBOARDING_SCOPES, ONBOARDING_PRO_SCOPES, ONBOARDING_ENTERPRISE_SCOPES } from 'onboarding-scopes/scopeConstants';
import { ownsAll, ownsNone } from './ownershipUtils';
import { getHasCoreEnterpriseSeat, getHasCoreProSeat } from '../utils/seatProducts';
export const getOwnsCrmSuiteStarter = scopes => {
  return ownsAll(scopes, STARTER_SUITE_ONBOARDING_SCOPES) && ownsNone(scopes, ONBOARDING_PRO_SCOPES) && ownsNone(scopes, ONBOARDING_ENTERPRISE_SCOPES);
};
export const getOwnsCrmSuitePro = scopes => {
  return ownsAll(scopes, PRO_SUITE_ONBOARDING_SCOPES) && ownsNone(scopes, ENTERPRISE_SUITE_ONBOARDING_SCOPES);
};
export const getOwnsCrmSuiteEnterprise = scopes => {
  return ownsAll(scopes, ENTERPRISE_SUITE_ONBOARDING_SCOPES);
};
export const getOwnsOnlySmartCrmPro = scopes => {
  return getHasCoreProSeat(scopes) && ownsNone(scopes, PRO_SUITE_ONBOARDING_SCOPES) && ownsNone(scopes, ENTERPRISE_SUITE_ONBOARDING_SCOPES);
};
export const getOwnsOnlySmartCrmEnterprise = scopes => {
  return getHasCoreEnterpriseSeat(scopes) && ownsNone(scopes, ENTERPRISE_SUITE_ONBOARDING_SCOPES);
};